var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Replace, Property 2=Inactive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14C17.2091 14 19 12.2091 19 10C19 7.79086 17.2091 6 15 6C12.7909 6 11 7.79086 11 10C11 12.2091 12.7909 14 15 14ZM15 15C18.866 15 22 18.134 22 22H8C8 18.134 11.134 15 15 15ZM39 32C39 34.2091 37.2091 36 35 36C32.7909 36 31 34.2091 31 32C31 29.7909 32.7909 28 35 28C37.2091 28 39 29.7909 39 32ZM35 37C38.866 37 42 40.134 42 44H28C28 40.134 31.134 37 35 37Z",
    fill: "#C3CBD3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 14C37.2091 14 39 12.2091 39 10C39 7.79086 37.2091 6 35 6C32.7909 6 31 7.79086 31 10C31 12.2091 32.7909 14 35 14ZM35 15C38.866 15 42 18.134 42 22H28C28 18.134 31.134 15 35 15ZM19 32C19 34.2091 17.2091 36 15 36C12.7909 36 11 34.2091 11 32C11 29.7909 12.7909 28 15 28C17.2091 28 19 29.7909 19 32ZM15 37C18.866 37 22 40.134 22 44H8C8 40.134 11.134 37 15 37Z",
    fill: "#E0E4E7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelocation);
export default __webpack_public_path__ + "static/media/relocation.48fbfd7994120c665b322b8c2418fb3d.svg";
export { ForwardRef as ReactComponent };